export default "__VITE_ASSET__59e67193__"